export default __webpack_public_path__ + "static/media/093-turn-right.e31aa7df.png";